import { ChangeDetectionStrategy, Component, inject, input, output } from '@angular/core';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ld-global-error-page',
  imports: [MatButtonModule, TranslocoDirective],
  templateUrl: './global-error-page.component.html',
  styleUrl: './global-error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalErrorPageComponent {
  private readonly transloco = inject(TranslocoService);

  readonly title = input<string>(this.transloco.translate('errorsServerError'));

  readonly message = input<string>(this.transloco.translate('errorsServerErrorMessage'));

  readonly showRetry = input<boolean>(true);

  readonly showHomeButton = input<boolean>(true);

  readonly retryButtonText = input<string>(this.transloco.translate('commonTryAgain'));

  readonly homeButtonText = input<string>(this.transloco.translate('errorsGoToDashboard'));

  readonly retry = output<void>();

  readonly goHome = output<void>();

  onRetry(): void {
    this.retry.emit();
  }

  onGoHome(): void {
    this.goHome.emit();
  }
}
